<template>
  <div>
    <slot />
  </div>
</template>

<script setup>
// 앱 스타일. 홈페이지(layouts/homepage.vue)에는 로드되지 않도록 전역(nuxt.config css)이 아닌 레이아웃에서 불러온다.
import "~/assets/css/style.css";
import "~/assets/scss/style.scss";
console.log("blank layout is rendering");
</script>
